import { withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-669011be")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    ref: "self",
    class: ["thumb", { selected: _ctx.isSelected, 'text-thumb': _ctx.isText(_ctx.object) }],
    style: {
      transform: `translateX(-50%) translateY(-50%) rotate(${_ctx.tempDeg}deg) scale(${_ctx.editorScale})`,
      left: `${_ctx.tempPos.x}px`,
      top: `${_ctx.tempPos.y}px`,
      width: _ctx.isImage(_ctx.object) ? `${_ctx.imageLimitWidth * _ctx.tempScale}px` : 'auto',
      height: _ctx.isImage(_ctx.object) ? `${_ctx.imageLimitHeight * _ctx.tempScale}px` : 'auto',
    },
    onDblclick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.state.isEditMode = true)),
    onPointerdown: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.draggable.pointerdown && _ctx.draggable.pointerdown(...args))),
    onPointerup: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.draggable.pointerup && _ctx.draggable.pointerup(...args))),
    onKeydown: [
      _cache[24] || (_cache[24] = _withKeys(($event: any) => (_ctx.moveUp($event)), ["up"])),
      _cache[25] || (_cache[25] = _withKeys(($event: any) => (_ctx.moveDown($event)), ["down"])),
      _cache[26] || (_cache[26] = _withKeys(($event: any) => (_ctx.moveLeft($event)), ["left"])),
      _cache[27] || (_cache[27] = _withKeys(($event: any) => (_ctx.moveRight($event)), ["right"]))
    ]
  }, [
    (_ctx.isText(_ctx.object))
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          ref: "content",
          class: ["text-content content", {
        'vertical-text': _ctx.object.isVertical,
        watermark: _ctx.iswatermark,
      }],
          style: {
        'line-height': `${_ctx.object.lineHeight}px`,
        'min-height': _ctx.object.isVertical
          ? _ctx.consts.minSerifHeight
          : _ctx.consts.minSerifWidth,
        'min-width': _ctx.object.isVertical
          ? _ctx.consts.minSerifWidth
          : _ctx.consts.minSerifHeight,
        'max-height': _ctx.object.isVertical ? '955px' : 'unset',
        'max-width': _ctx.object.isVertical ? 'unset' : '1295px',
      },
          contenteditable: _ctx.state.isEditMode,
          onPointerdown: _cache[1] || (_cache[1] = ($event: any) => {if (_ctx.state.isEditMode) $event.stopPropagation();}),
          onKeydown: [
            _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.leftKey($event, _ctx.object)), ["up"])),
            _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.upKey($event, _ctx.object)), ["right"])),
            _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.rightKey($event, _ctx.object)), ["down"])),
            _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.downKey($event, _ctx.object)), ["left"])),
            _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["stop"]), ["delete"])),
            _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.limitedMaxLength && _ctx.limitedMaxLength(...args)))
          ],
          onPaste: _cache[8] || (_cache[8] = ($event: any) => (_ctx.paste($event))),
          onCopy: _cache[9] || (_cache[9] = ($event: any) => (_ctx.copy($event))),
          innerHTML: _ctx.sanitize(_ctx.preContent),
          onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.inputText($event.target)))
        }, null, 46, ["contenteditable", "innerHTML"]))
      : _createCommentVNode("", true),
    (_ctx.isImage(_ctx.object))
      ? (_openBlock(), _createBlock("img", {
          key: 1,
          ref: "content",
          class: "image-content content",
          draggable: "false",
          src: _ctx.toResourceUrl(_ctx.object.image.path),
          width: _ctx.imageLimitWidth,
          height: _ctx.imageLimitHeight
        }, null, 8, ["src", "width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.isSelected)
      ? (_openBlock(), _createBlock("span", {
          key: 2,
          class: "rotate-handle handle",
          onPointerdown: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rotate.pointerdown && _ctx.rotate.pointerdown(...args)), ["stop"])),
          onPointerup: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rotate.pointerup && _ctx.rotate.pointerup(...args)), ["stop"]))
        }, null, 32))
      : _createCommentVNode("", true),
    (_ctx.isSelected && _ctx.isImage(_ctx.object))
      ? (_openBlock(), _createBlock("span", {
          key: 3,
          class: "resize-handle-lt handle",
          onPointerdown: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.scale.pointerdown($event, _ctx.anchors.rightBottom)), ["stop"])),
          onPointerup: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scale.pointerup && _ctx.scale.pointerup(...args)), ["stop"]))
        }, null, 32))
      : _createCommentVNode("", true),
    (_ctx.isSelected && _ctx.isImage(_ctx.object))
      ? (_openBlock(), _createBlock("span", {
          key: 4,
          class: "resize-handle-rt handle",
          onPointerdown: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.scale.pointerdown($event, _ctx.anchors.leftBottom)), ["stop"])),
          onPointerup: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scale.pointerup && _ctx.scale.pointerup(...args)), ["stop"]))
        }, null, 32))
      : _createCommentVNode("", true),
    (_ctx.isSelected && _ctx.isImage(_ctx.object))
      ? (_openBlock(), _createBlock("span", {
          key: 5,
          class: "resize-handle-lb handle",
          onPointerdown: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.scale.pointerdown($event, _ctx.anchors.rightTop)), ["stop"])),
          onPointerup: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scale.pointerup && _ctx.scale.pointerup(...args)), ["stop"]))
        }, null, 32))
      : _createCommentVNode("", true),
    (_ctx.isSelected && _ctx.isImage(_ctx.object))
      ? (_openBlock(), _createBlock("span", {
          key: 6,
          class: "resize-handle-rb handle",
          onPointerdown: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.scale.pointerdown($event, _ctx.anchors.leftTop)), ["stop"])),
          onPointerup: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scale.pointerup && _ctx.scale.pointerup(...args)), ["stop"]))
        }, null, 32))
      : _createCommentVNode("", true)
  ], 38))
})